import { ChangeDetectionStrategy, Component, computed, effect, input } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { TelemetryService } from "../../services/telemetry.service";
import { SeEmailSentComponent } from "../student-engagement/email/se.email.sent.component";

export const EVENT_EMAIL_HISTORY_SCOPE_HINT =
    "Threaded emails sent for this event. Only messages sent with conversation threading enabled appear here.";

@TypeManagerDecorator("s25-ng-event-email-history")
@Component({
    selector: "s25-ng-event-email-history",
    host: { class: "event-email-history" },
    template: `
        @if (resolvedEventId() != null) {
            <s25-ng-se-email-sent [fixedEventId]="resolvedEventId()!" [scopeHint]="scopeHint" />
        }
    `,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SeEmailSentComponent],
})
export class S25EventEmailHistoryComponent {
    readonly itemId = input<number | string | undefined>(undefined);
    readonly scopeHint = EVENT_EMAIL_HISTORY_SCOPE_HINT;

    readonly resolvedEventId = computed((): number | null => {
        const rawId = this.itemId();
        const eventId = typeof rawId === "string" ? Number(rawId) : rawId;
        if (eventId == null || !Number.isFinite(eventId)) {
            return null;
        }
        return eventId;
    });

    private telemetrySent = false;

    constructor() {
        effect(() => {
            const eventId = this.resolvedEventId();
            if (eventId == null || this.telemetrySent) {
                return;
            }
            this.telemetrySent = true;
            TelemetryService.sendWithSub("EventDetails", "EmailHistory", "Visit");
        });
    }
}
